document.querySelectorAll('[data-category-viewport]').forEach((viewport) => {
  const section = viewport.closest('.category-showcase');
  const prevBtn = section.querySelector('[data-category-prev]');
  const nextBtn = section.querySelector('[data-category-next]');
  const scrollAmount = 320;

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      viewport.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      viewport.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }
});
